import { render, staticRenderFns } from "./UserPointRow.vue?vue&type=template&id=484d0510&scoped=true&"
import script from "./UserPointRow.vue?vue&type=script&lang=js&"
export * from "./UserPointRow.vue?vue&type=script&lang=js&"
import style0 from "./UserPointRow.vue?vue&type=style&index=0&id=484d0510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d0510",
  null
  
)

export default component.exports